// MuiDatePicker

import { darkPalette } from "../palette";

export const MuiDatePicker = {
  MuiCalendarPicker: {
    styleOverrides: {
      root: {
        "&, .MuiPaper-root": {
          backgroundColor: darkPalette.background.paper,
          backgroundImage: "none",
          color: darkPalette.text.primary,
          "& .MuiPickersDay-root:not(.Mui-selected)": {
            backgroundColor: darkPalette.background.paper,
            color: darkPalette.text.primary,
            "&:hover": {
              backgroundColor: darkPalette.secondary.light,
            },
            "&:disabled": {
              opacity: "0.25",
            },
          },
          "& .MuiIconButton-root, .MuiButtonBase-root:not(.Mui-selected)": {
            color: darkPalette.text.primary,
          },
          "& .MuiClockPicker-arrowSwitcher ~ div": {
            "& span": {
              color: darkPalette.text.primary,
            },
          },
        },
      },
    },
  },
  MuiDateTimePicker: {
    styleOverrides: {
      root: {
        "&.MuiTabs-root, & .MuiTabs-root": {
          backgroundCOlor: "red",
        },
        backgroundColor: "red",
        "&, .MuiPaper-root": {
          backgroundColor: "red", //darkPalette.background.paper,
          backgroundImage: "none",
          color: darkPalette.text.primary,
          "& .MuiClockPicker-arrowSwitcher ~ div": {
            "& span": {
              color: darkPalette.text.primary,
            },
          },
        },
      },
    },
  },
};
